import {useEffect} from "react";
import {useHistory, useLocation, Route, Switch, Redirect} from "react-router-dom";
import {Tab, Tabs, Alert} from "@mui/material";
import {useIsSuper} from "../../state/UserContextProvider";
import {AdminNamespacesTab} from "./AdminNamespacesTab";
import {AdminAccountsTab} from "./AdminAccountsTab";
import {AdminUsersTab} from "./AdminUsersTab";
import {NamespaceDetails} from "./NamespaceDetails";
import {AccountDetails} from "./AccountDetails";
import {UserDetails} from "./UserDetails";

const tabs = [
    {path: "/admin/namespaces", label: "Namespaces"},
    {path: "/admin/accounts", label: "Accounts"},
    {path: "/admin/users", label: "Users"},
];

export function AdminSection() {
    var isSuper = useIsSuper();
    var history = useHistory();
    var location = useLocation();

    var currentTab = tabs.findIndex(tab => location.pathname.startsWith(tab.path));
    if (currentTab === -1) currentTab = 0;

    useEffect(() => {
        if (location.pathname === "/admin") {
            history.replace("/admin/namespaces");
        }
    }, [location.pathname, history]);

    if (!isSuper) {
        return <Alert severity="error" sx={{m: 2}}>Access Denied - Super user permissions required</Alert>;
    }

    function handleTabChange(_: any, index: number) {
        history.push(tabs[index].path);
    }

    return (
        <div style={{padding: "0 16px"}}>
            <Tabs value={currentTab} onChange={handleTabChange} sx={{mb: 2}}>
                {tabs.map(tab => <Tab key={tab.path} label={tab.label}/>)}
            </Tabs>

            <Switch>
                <Route exact path="/admin/namespaces/:key"><NamespaceDetails/></Route>
                <Route exact path="/admin/accounts/:key"><AccountDetails/></Route>
                <Route exact path="/admin/users/:id"><UserDetails/></Route>
                <Route path="/admin/namespaces"><AdminNamespacesTab/></Route>
                <Route path="/admin/accounts"><AdminAccountsTab/></Route>
                <Route path="/admin/users"><AdminUsersTab/></Route>
                <Redirect from="/admin" to="/admin/namespaces"/>
            </Switch>
        </div>
    );
}
